import React from "react";
import ReactECharts from 'echarts-for-react';
import { useState, useEffect } from "react";
import { getMetadata } from '../../services/MetadataService';
import { getLastTickerIndicatorHistorical } from "../../services/TickerIndicatorHistoricalService";
import { useParams } from "react-router-dom";

const GaugeChart = ({param}) => {

    const [ultoscrsitvss, setUltoscrsitvss] = useState([0, 0, 0]);

    const [minUltosc, setMinUltosc] = useState('');
    const [maxUltosc, setMaxUltosc] = useState('');

    const [minRsi, setMinRsi] = useState('');
    const [maxRsi, setMaxRsi] = useState('');

    const [minTvs, setMinTvs] = useState('');
    const [maxTvs, setMaxTvs] = useState('');

    const [value, setValue] = useState('')

    const [ ultOscPer, setUltOscPer] = useState(0);
    const [ rsiPer   , setRsiPer   ] = useState(0);
    const [ tvsPer   , setTvsPer   ] = useState(0);

    var { page } = useParams(); page      = "1";

    useEffect(() => {
        const interval = setInterval(() => {
            getLastTickerIndicatorHistoricalData();

            getMetadataData("dukas.graphs");

            getMetadataData("min.ultosc"); getMetadataData("max.ultosc");
            getMetadataData("min.rsi")   ; getMetadataData("max.rsi");
            getMetadataData("min.tvs")   ; getMetadataData("max.tvs");

            if (ultoscrsitvss[0].ultOsc !== undefined) setUltOscPer(calculePercent(ultoscrsitvss[0].ultOsc.toFixed(8), minUltosc, maxUltosc, 0, 100));
            if (ultoscrsitvss[0].rsi    !== undefined) setRsiPer(calculePercent(ultoscrsitvss[0].rsi.toFixed(8), minRsi, maxRsi, 0, 100));
            if (ultoscrsitvss[0].tvs    !== undefined) setTvsPer(calculePercent(ultoscrsitvss[0].tvs.toFixed(8), minTvs, maxTvs, 0, 100));

            // console.log("ultoscrsitvss[0].ultOsc : "  + ultoscrsitvss[0].ultOsc);
            // console.log("ultOscPer : " + ultOscPer);

            setOption((option) => ({
                series: [
                    {
                        data: [{value: ultOscPer.toFixed(2), name: 'ultOsc'}],
                    },
                    {
                        data: [{value: rsiPer.toFixed(2), name: 'rsi'}],
                    },
                    {
                        data: [{value: tvsPer.toFixed(2), name: 'tvs'}],
                    },
                ]
            }));

        }, 1000);

        return () => {
            clearInterval(interval);
        }
    });

    function calculePercent(defValue, minDef, maxDef, newMin, newMax) {
         return ((defValue - minDef) / (maxDef - minDef)) * (newMax - newMin) + newMin;
    }

    function getLastTickerIndicatorHistoricalData() {
        getLastTickerIndicatorHistorical(param, page).then((response) => {
            setUltoscrsitvss(response.data);
        }).catch(error => {
            console.log(error);
        })
    }

    function getMetadataData(name) {
        switch (name) {
            case "dukas.graphs" :
                getMetadata("dukas.graphs").then((response) => {
                    setValue(response.data.value)
                }).catch(error => {
                    console.log(error);
                }); break;
            case "min.ultosc" :
                getMetadata("min.ultosc." + param).then((response) => {
                    setMinUltosc(response.data.value);
                }).catch(error => {
                    console.log(error);
                }); break;
            case "max.ultosc" :
                getMetadata("max.ultosc." + param).then((response) => {
                    setMaxUltosc(response.data.value);
                }).catch(error => {
                    console.log(error);
                }); break;
            case "min.rsi" :
                getMetadata("min.rsi." + param).then((response) => {
                    setMinRsi(response.data.value);
                }).catch(error => {
                    console.log(error);
                }); break;
            case "max.rsi" :
                getMetadata("max.rsi." + param).then((response) => {
                    setMaxRsi(response.data.value);
                }).catch(error => {
                    console.log(error);
                }); break;
            case "min.tvs" :
                getMetadata("min.tvs." + param).then((response) => {
                    setMinTvs(response.data.value);
                }).catch(error => {
                    console.log(error);
                }); break;
            case "max.tvs" :
                getMetadata("max.tvs." + param).then((response) => {
                    setMaxTvs(response.data.value);
                }).catch(error => {
                    console.log(error);
                }); break;
            default: break;
        }
    }

    function showGaugeGraphs(style) {
        if (style === "width" && value === "true") return "950px";
        if (style === "height" && value === "true") return "300px";
        return "0px";
    }

    const [option, setOption] = useState({
        series: [
            {   type: 'gauge',
                center: ['20%', '50%'], // Left gauge
                startAngle: 180,
                endAngle: 0,
                progress: {
                    show: true,
                    width: 7,
                    itemStyle: {
                        color: '#F33939'  // Change progress bar color here
                    }
                },
                axisLine: {
                    lineStyle: {
                        width: 16,
                        color: [
                            [0.3, '#E7EAFE'], // Color for 0-30%
                            [0.7, '#909EF9'], // Color for 30-70%
                            [1, '#3952F3']  // Color for 70-100%
                        ]
                    },
                },
                pointer: {
                    show: true,
                    length: '55%',
                    width: 5,
                    itemStyle: {
                        color: '#808080'  // Pointer color, can be a specific color string
                    }
                },
                name: {
                    // This controls the font of the name label
                    textStyle: {
                        fontSize: 20,
                        fontWeight: 'bold',
                        fontFamily: 'Arial',
                        color: '#808080'
                    }
                },
                detail: {
                    valueAnimation: true,
                    formatter: '{value}%',
                    color: 'auto',
                    textStyle: {
                        fontSize: 17,
                        fontWeight: 'normal',
                        fontFamily: 'Verdana',
                        color: '#808080'
                    }
                },
                data: [
                    {
                        value: 0,
                        name: 'ultOsc',
                    },
                ],
            },
            {
                type: 'gauge',
                center: ['50%', '50%'], // Center gauge
                startAngle: 180,
                endAngle: 0,
                progress: {
                    show: true,
                    width: 7,
                    itemStyle: {
                        color: '#F33939'  // Change progress bar color here
                    }
                },
                axisLine: {
                    lineStyle: {
                        width: 16,
                        color: [
                            [0.3, '#dbf3db'], // Color for 0-30%
                            [0.7, '#b4dcb4'], // Color for 30-70%
                            [1, '#14a30e']  // Color for 70-100%
                        ]
                    },
                },
                pointer: {
                    show: true,
                    length: '55%',
                    width: 5,
                    itemStyle: {
                        color: '#808080'  // Pointer color, can be a specific color string
                    }
                },
                name: {
                    // This controls the font of the name label
                    textStyle: {
                        fontSize: 20,
                        fontWeight: 'bold',
                        fontFamily: 'Arial',
                        color: '#808080'
                    }
                },
                detail: {
                    valueAnimation: true,
                    formatter: '{value}%',
                    color: 'auto',
                    textStyle: {
                        fontSize: 17,
                        fontWeight: 'normal',
                        fontFamily: 'Verdana',
                        color: '#808080'
                    }
                },
                data: [
                    {
                        value: 0,
                        name: 'rsi',
                    },
                ],
            },
            {
                type: 'gauge',
                center: ['80%', '50%'], // Center gauge
                startAngle: 180,
                endAngle: 0,
                progress: {
                    show: true,
                    width: 7,
                    itemStyle: {
                        color: '#F33939'  // Change progress bar color here
                    }
                },
                axisLine: {
                    lineStyle: {
                        width: 16,
                        color: [
                            [0.3, '#f8e7dd8c'], // Color for 0-30%
                            [0.7, '#f4a603'], // Color for 30-70%
                            [1, '#d8790c']  // Color for 70-100%
                        ]
                    },
                },
                pointer: {
                    show: true,
                    length: '55%',
                    width: 5,
                    itemStyle: {
                        color: '#808080'  // Pointer color, can be a specific color string
                    }
                },
                name: {
                    // This controls the font of the name label
                    textStyle: {
                        fontSize: 20,
                        fontWeight: 'bold',
                        fontFamily: 'Arial',
                        color: '#808080'
                    }
                },
                detail: {
                    valueAnimation: true,
                    formatter: '{value}%',
                    color: 'auto',
                    textStyle: {
                        fontSize: 17,
                        fontWeight: 'normal',
                        fontFamily: 'Verdana',
                        color: '#808080'
                    }
                },
                data: [
                    {
                        value: 0,
                        name: 'tvs',
                    },
                ],
            },
        ],
    });

    return (
        <>
            <div className="chart-container">
                <ReactECharts
                    option={option}
                    style={{width: showGaugeGraphs("width"), height: showGaugeGraphs("height")}}>
                </ReactECharts>
            </div>
        </>
    )
}

export default GaugeChart;